var map = {
	"./alert-danger.svg": 74500,
	"./alert.svg": 36367,
	"./arrow.svg": 89442,
	"./back-arrow.svg": 39985,
	"./bars.svg": 83695,
	"./calendar.svg": 24872,
	"./campaigns/fb.svg": 31285,
	"./campaigns/salesforce.svg": 66470,
	"./cart.svg": 64467,
	"./check-bt.svg": 53183,
	"./check.svg": 73028,
	"./close.svg": 2591,
	"./config.svg": 66938,
	"./customer.svg": 95217,
	"./database.svg": 94647,
	"./digital_influenced.svg": 26621,
	"./dollar.svg": 47029,
	"./download-2.svg": 2451,
	"./download.svg": 3221,
	"./ecommerce.svg": 53361,
	"./engagement.svg": 62060,
	"./expand.svg": 3727,
	"./eye-blocked.svg": 38986,
	"./eye.svg": 9947,
	"./filter.svg": 73232,
	"./info-black.svg": 42118,
	"./info.svg": 33974,
	"./instore.svg": 61445,
	"./integrations/360.svg": 40603,
	"./integrations/adobe.svg": 22086,
	"./integrations/allin.svg": 77020,
	"./integrations/bigquery.svg": 17864,
	"./integrations/blank.svg": 3330,
	"./integrations/facebook.svg": 10078,
	"./integrations/gcs.svg": 75231,
	"./integrations/google.svg": 73057,
	"./integrations/googleads.svg": 50169,
	"./integrations/googledv360.svg": 50517,
	"./integrations/linkedin.svg": 37454,
	"./integrations/maxymiser.svg": 59453,
	"./integrations/omnichat.svg": 47340,
	"./integrations/oto.svg": 23880,
	"./integrations/responsys.svg": 26835,
	"./integrations/s3.svg": 59520,
	"./integrations/salesforce.svg": 64071,
	"./integrations/sftp.svg": 75930,
	"./integrations/vtex.svg": 66614,
	"./integrations/wavy.svg": 39591,
	"./integrations/youtube.svg": 39909,
	"./integrations/zenvia.svg": 21074,
	"./mail.svg": 62711,
	"./media.svg": 36407,
	"./new-alert.svg": 42615,
	"./omni.svg": 97941,
	"./options.svg": 72410,
	"./plus.svg": 94893,
	"./refresh.svg": 79616,
	"./rename.svg": 33824,
	"./search.svg": 77618,
	"./segment.svg": 37586,
	"./select-arrow.svg": 97646,
	"./stars-2.svg": 18664,
	"./stars-ia.svg": 15250,
	"./stars.svg": 59398,
	"./success-green.svg": 70663,
	"./success.svg": 37111,
	"./trash.svg": 3996,
	"./user-check-01.svg": 87142,
	"./user-customer-distribution.svg": 14518,
	"./user-x-01.svg": 66776,
	"./warning.svg": 46659,
	"./welcome/alert.svg": 51258,
	"./welcome/arrow-right.svg": 61881,
	"./welcome/bell.svg": 837,
	"./welcome/graduation.svg": 40087,
	"./welcome/money.svg": 51987,
	"./welcome/notification.svg": 58607,
	"./welcome/question.svg": 46718,
	"./welcome/report.svg": 96099,
	"./welcome/smile.svg": 92400,
	"./welcome/users.svg": 42037
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12107;